import { render, staticRenderFns } from "./RegulatoryUpdateCloseModal.vue?vue&type=template&id=69cd3f96&scoped=true"
import script from "./RegulatoryUpdateCloseModal.vue?vue&type=script&lang=ts"
export * from "./RegulatoryUpdateCloseModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69cd3f96",
  null
  
)

export default component.exports